/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { SessionContext } from '../../../context/SessionContext';
import { EngagementData } from '../../../services/EngagementService';
import { Flex, Link, Text } from '@getgo/chameleon-chakra-ui';
import {
  TelemetryAction,
  TelemetryComponent,
  TelemetryState,
  useSendTelemetry,
} from '../../../hooks/useSendTelemetry';
import { defineMessages, useIntl } from 'react-intl';
import { reloadPageWithSessionTrackingId } from '../../../services/NavigatorService';
import { SuccessIcon } from './SuccessIcon';
import { SuccessMarketing } from './SuccessMarketing';

const messages = defineMessages({
  headingInstallFlow: {
    id: 'success.heading.install',
  },
  description: {
    id: 'success.description',
  },
  redownloadLink: {
    id: 'success.redownload',
  },
});

interface VisualisationProps {
  engagement: EngagementData | null;
}

export const InstallSuccessPage: React.FC<VisualisationProps> = ({
  engagement,
}) => {
  const { meetingId, sessionTrackingId } = useContext(SessionContext);
  const sendTelemetry = useSendTelemetry();
  const { formatMessage: f } = useIntl();

  return (
    <Flex
      direction='column'
      alignItems='center'
      justifyContent='flex-start'
      id='successStatus'
      minH='60vh'
      pt='6vh'
      pb='8vh'
    >
      <Flex direction='column' justifyContent='center' alignItems='center'>
        <Text as='h1'>{f(messages.headingInstallFlow)}</Text>
        {!engagement && <SuccessIcon />}
      </Flex>
      <Flex marginTop='2rem' direction='column' alignItems='center'>
        <Text>{f(messages.description)}</Text>
        <Link
          textDecoration='underline'
          href=''
          onClick={() => {
            sendTelemetry(
              TelemetryComponent.Native,
              TelemetryAction.Retry,
              TelemetryState.Success
            );
            reloadPageWithSessionTrackingId(meetingId, sessionTrackingId);
          }}
        >
          {f(messages.redownloadLink)}
        </Link>
      </Flex>
      {engagement && <SuccessMarketing engagementData={engagement} />}
    </Flex>
  );
};
